<template>
  <div>
    <!-- 两种情况共用本页：
         1）从列表页点「编辑/新增」进来：$route.params 带整条申报记录 → params 有值，走回填（含封面图、已上传文件）
         2）从菜单「网络育人联盟」直接进入：$route.params 为空 → params 为 null，走空白新增 -->
    <al-apply
      :key="$route.fullPath"
      :editInfo="params"
      :fromEnrollParams="fromEnrollParams"
    >
    </al-apply>
  </div>
</template>

<script>
import alApply from "@/components/alApplyFileupload/index";
export default {
  name: "",
  components: {
    alApply,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    // 编辑回填数据：只有携带 applyFiles 的完整申报记录才算「编辑」，菜单直接进入时为 null（空白新增）
    params() {
      const p = this.$route.params || {};
      if (p.applyFiles) {
        return p;
      }
      return null;
    },
    // 从大赛报名流程跳转过来时携带的报名信息
    fromEnrollParams() {
      const p = this.$route.params || {};
      return p.fromEnroll ? p : null;
    },
  },
  watch: {},
  created() {
    // 菜单直接进入（无任何传入参数）时清掉上一次申报残留的缓存，
    // 否则 qbsj / step 草稿里的旧记录会被回填，导致「新增」变成「修改」
    const p = this.$route.params || {};
    const hasParams = p.id || p.fromEnroll || p.zpname || p.applyFiles;
    if (!hasParams) {
      sessionStorage.removeItem("qbsj");
      if (this.$store.state.user && this.$store.state.user.id) {
        sessionStorage.removeItem(`step${this.$store.state.user.id}`);
      }
    }
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
